import { render, staticRenderFns } from "./OneImage.vue?vue&type=template&id=a165c02c&scoped=true&"
import script from "./OneImage.vue?vue&type=script&lang=js&"
export * from "./OneImage.vue?vue&type=script&lang=js&"
import style0 from "./OneImage.vue?vue&type=style&index=0&id=a165c02c&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a165c02c",
  null
  
)

export default component.exports